


















import { VueCustom } from 'vue-custom';
import EventsManager from 'managers/events.manager';

import Workspace from 'components/workspace/index.vue';
import Library from 'components/library/index.vue';
import Search from 'components/search.vue';
import Menu from 'components/menu/index.vue';
import TextTutorials from 'components/text-tutorials.vue';

export default VueCustom.extend({
  name: 'game',
  components: {
    Workspace,
    Library,
    Search,
    Menu,
    Tutorials: () => import(/* webpackChunkName: "tutorials" */ 'components/tutorials.vue'),
    TextTutorials,
    Animations: () => import(/* webpackChunkName: "animations" */ 'components/animations/index.vue'),
  },
  computed: {
    areTutorialsVisible(): boolean {
      return !this.$store.getters.areTutorialsFinished;
    },
  },
  mounted() {
    EventsManager.once('PLAY', () => this.$store.dispatch('startedPlaying'));
  },
});
